/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../../hooks/useForm';
import { isEmpty } from 'lodash';
import systemAlert from '../../../utils/systemAlert';
import Filters from '../../Filters';
import { ControlTable } from '../../Table';
import { allCanceledBilling, getBillings } from '../../../apis/tax-portal/billing';
import { getParams as _getParams } from '../../../utils/params';
import { MANAGEMENT_PAYMENT_TYPE, PAYMENT_TYPE } from '../../../constants/TaxPortal/MANAGEMENT_CONTACT_TYPE';
import Contract from './Contract';
import { toast } from '../../../utils/toast';

const Contracts = () => {
  const [tableButtons, setTableButtons] = useState([]);

  const [filters] = useState([
    {
      title: "상호명 또는 대표명",
      type: "input",
      key: "search.keyword",
      placeholder: "상호명 또는 대표명 입력",
    },
    {
      title: "상품명",
      key: "search.title",
      placeholder: "상품명 입력",
    },
    {
      title: "청구유형",
      key: "search.type",
      type: "select",
      options: {
        list: [{ label: "전체", value: "all" }, ...MANAGEMENT_PAYMENT_TYPE.slice(1)]
      }
    },
    {
      title: "납부방식",
      type: "select",
      key: "search.paymentType",
      options: {
        list: [{ label: "전체", value: "all" }, ...PAYMENT_TYPE]
      }
    },
    {
      title: "위케이크 사용여부",
      type: "radio",
      key: "search.isWecake",
      className: "margin-right-16",
      options: {
        list: [
          { label: "전체", value: "2" },
          { label: "사용중", value: "1" },
          { label: "사용안함", value: "0" },
        ],
      },
    },

  ]);

  const [fields] = useState([
    {
      title: "청구 시작일",
      key: "payStartDate",
      type: "date"
    },
    {
      title: "청구 해지일",
      key: "expiryDate",
    },
    {
      title: "계약명",
      key: "title",
    },
    {
      title: "수임회사명",
      key: "management.companyName",
    },
    {
      title: "대표자명",
      key: "management.ceoName",
    },
    {
      title: "사업자등록번호",
      key: "management.bsno",
      transform: ['comNum']
    },
    {
      title: "청구유형",
      key: "type",
      onValue: (v, _f, d) => {
        v = d?.status === "cancel" ? "cancel" : v;
        return (
          <span className={`${v === "cancel" ? "error" : ""}`}>
            {MANAGEMENT_PAYMENT_TYPE.find(f => f.value === v)?.label}
          </span>
        );
      }
    },
    {
      title: "금액",
      key: "price",
      transform: "comma"
    },
    {
      title: "납부방식",
      key: "paymentType",
      onValue: (v) => {
        return PAYMENT_TYPE.find(f => f.value === v)?.label;
      }
    },
    {
      title: "wecake Biz 사용여부",
      key: "management.companyToTaxpayer.company",
      onValue: (v) => !isEmpty(v) ? "O" : "X"
    },
  ]);

  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit,
  } = useForm({
    offset: 0,
    limit: 10,
    order: [
      {
        payStartDate: "desc",
      },
    ],
    search: {
      isWecake: "2",
      paymentType: "all",
      type: "all",
    },
  });


  useEffect(() => {
    setSubmit(submit);
    submit(form);
  }, []);


  const getParams = (params) => {

    if (params?.search?.paymentType === "all")
      delete params.search.paymentType;

    if (params?.search?.type === "all")
      delete params.search.type;

    params = {
      ...params,
      search: {
        ...params?.search,
        isWecake: !isEmpty(params?.search?.isWecake) ? +params?.search?.isWecake : 2,
      }
    };

    return _getParams(params);

  };

  const submit = (form) => {
    getBillings(getParams(form))
      .then(res => {
        const { rows, count } = res;
        setList(rows || []);
        setTotal(count);
      }).finally(() => setIsLoading(false));
  };


  useEffect(() => {
    setTableButtons([
      {
        label: "계약 해지",
        color: "red",
        disabled: isEmpty(selectedList),
        action: () => {
          if (selectedList.length > 0) {
            systemAlert(`"${selectedList[0].title}" ${selectedList.length - 1 > 0 ? ` 외 ${selectedList.length - 1}개` : ""}의 계약해지를 진행하시겠습니까`, {
              buttons: [
                {
                  color: 'text',
                  label: '취소'
                },
                {
                  label: '해지',
                  color: 'red',
                  onClick: () => {
                    allCanceledBilling({ idx: selectedList.map(item => item.idx) }).then(res => {
                      toast.success("해지가 완료되었습니다.");
                      reSubmit();
                    });
                  }
                }
              ]
            });
          }
        },
      },
      {
        label: "새로운 계약 등록",
        action: () => {
          setDetailOpen(true);
        },
      }
    ]);
  }, [selectedList]);

  const onSelect = (data, e) => {
    setSelectedItem(data);
    setDetailOpen(true);
  };


  const getCheckboxDisabled = (data) => {
    let disabled = false;

    if (data.status === "cancel") {
      disabled = true;
    }

    return disabled;
  };


  return (
    <>
      <Filters
        filters={filters}
        isLoading={isLoading}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isHideAllCheck
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        buttons={tableButtons}
        onSelect={onSelect}
        checkboxDisabled={getCheckboxDisabled}
      />

      <Contract
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={reSubmit}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    </>
  );
};

export default Contracts;